export default "__VITE_ASSET__Cft_bj1s__"